<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div>
          <!--            :date-format="(e) => selectDate(e)"-->
          <date-range-picker
            ref="picker"
            :startDate="startDate"
            opens="right"
            :ranges="ranges"
            :locale-data="date_locale"
            v-model="dateRange"
            @update="selectDate"
          >
          </date-range-picker>
          <LoadingButton
            title="Показать"
            className="btn btn-outline-info"
            :loading="loading"
            :color="loadingColor"
            :onClick="() => showRating()"
          />
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body rating_table">
        <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>
        <div v-if="!loading && records">
          <div class="form-group">
            <label for="">Количество записей на странице</label>
            <input type="number" @change="updatePerPage" placeholder="Количество" class="form-control" style="max-width:200px">
          </div>
          <data-table ref="tableData" v-bind="tableData"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import DateRangePicker from 'vue2-daterange-picker'
import moment from "moment";
import LoadingButton from "@/components/buttons/LoadingButton";
import DataTable from "@andresouzaabreu/vue-data-table";
import "@andresouzaabreu/vue-data-table/dist/DataTable.css";

export default {
  components: {
    DateRangePicker,
    LoadingButton,
    DataTable,
  },
  data() {
    return {
      sortedRecords: [],
      tableData: {
        sortingMode: 'single',
        showDownloadButton: false,
        showEntriesInfo: false,
        defaultPerPage: 4,
        text: {
          PerPageText: "Препаратов на странице :entries",
          infoText: "Показано :first по :last из :total препаратов",
          emptyTableText: "Ничего не найдено :(",
          previousButtonText: 'Предидущая',
          nextButtonText: 'Следующая',
          searchText: 'Поиск: ',
          perPageText: ':entries препаратов на старнице',
          paginationSearchText: 'Перейти на страницу',
        },
        columns: [
          {title: 'ID', key: 'drug_id', sortable: false, type: 'number'},
          {title: 'Препарат', key: 'title', sortable: true, type: 'string'},
          {title: 'Упаковок', key: 'totalQty', sortable: true, type: 'number'},
          {title: 'Вал в EUR', key: 'totalPrice', sortable: true, type: 'number'},
          {title: 'Прибыль в EUR', key: 'income', sortable: true, type: 'number'},
          {title: 'Приоритет', key: 'priority', sortable: false, type: 'number'},
        ],
        data: [],
      },
      records: null,
      loading: false,
      loadingColor: this.$constants.LOADING_COLOR,
      dateRange: {
        startDate: moment().startOf('isoWeek'),
        endDate: moment().endOf('isoWeek'),
      },
      startDate: '',
      ranges: { //default value for ranges object (if you set this to false ranges will no be rendered)
        'Текущая неделя': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
        'Прошлая неделя': [moment().subtract(1, 'isoWeek').startOf('isoWeek'), moment().subtract(1, 'isoWeek').endOf('isoWeek')],
        'Текущий месяц': [moment().startOf('month'), moment().endOf('month')],
        'Прошлый месяц': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      date_locale: {
        firstDay: 1,
        format: 'DD-MM-YYYY',
        applyLabel: 'Выбрать',
        cancelLabel: 'Отмена',
        daysOfWeek: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      },
    }
  },
  methods: {
    selectDate(e) {
      console.log(e);
    },
    updatePerPage(e) {
      const perPage = +e.target.value;
      if (perPage < 1) return;
      this.$refs.tableData.currentPerPage = perPage;
    },
    async showRating() {
      this.loading = true;
      this.records = null;
      const {data} = await api.post('/new/drugs/rating', {
        start: moment(this.dateRange.startDate).format('YYYY-MM-DD'),
        end: moment(this.dateRange.endDate).format('YYYY-MM-DD'),
      });
      if (data.success) {
        this.records = data.records;
        this.tableData.data = data.records;
        this.drugs = data.drugs;
      } else {
        toastr["warning"](data.message || "Ошибка ответа сервера");
      }
      this.loading = false;
    }
  }
}

</script>

<style>
.rating_table .data-table-pagination {
  max-width: none;
}

.rating_table .data-table-table {
  max-height: none;
}

.rating_table .data-table-table thead th:nth-child(3),
.rating_table .data-table-table thead th:nth-child(4),
.rating_table .data-table-table thead th:nth-child(5),
.rating_table .data-table-table thead th:nth-child(6) {
  width: 170px;
}
</style>
